import { render, staticRenderFns } from "./content-header.vue?vue&type=template&id=f4543e32&scoped=true"
import script from "./content-header.vue?vue&type=script&lang=js"
export * from "./content-header.vue?vue&type=script&lang=js"
import style0 from "./content-header.vue?vue&type=style&index=0&id=f4543e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4543e32",
  null
  
)

export default component.exports